import React, {  useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import styles from '../../../SPEventLiabilityStyles.module.scss'
import metadata from './UnderwritingInformationComponent.metadata.json5';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function UnderwritingInformationComponent(props) {

const { submissionVM, updateWizardData,pathUpdated} = props;
const breakpoint = useContext(BreakpointTrackerContext);
const { onValidate } = useValidation('UnderwritingInformationComponent');
const modelVM = _.get(submissionVM, pathUpdated);

modelVM.value.isValidationReq = true;


// eslint-disable-next-line react-hooks/exhaustive-deps
  const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        ifYesPleProFulDet3: {
            visible:  _.get(modelVM, 'hasAnyInsEveCanDecOr2.value') !== undefined && _.get(modelVM, 'hasAnyInsEveCanDecOr2.value')
        },
        doYouOrAnyLivUndYou4: {
            visible: _.get(submissionVM.value, 'baseData.baseState_Ext') !== undefined &&
                _.get(submissionVM.value, 'baseData.baseState_Ext') === 'QC',
            required: _.get(submissionVM.value, 'baseData.baseState_Ext') !== undefined &&
                _.get(submissionVM.value, 'baseData.baseState_Ext') === 'QC'
        },
        ifYesProDet5: {
            visible:  _.get(modelVM, 'doYouOrAnyLivUndYou4.value') !== undefined && _.get(modelVM, 'doYouOrAnyLivUndYou4.value')
        }
    };


const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles
    };

const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM,pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM,`${fullPath}`,value);

            updateWizardData(submissionVM);         
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

return (
            <ViewModelForm
                uiProps={metadata.componentContent}
                model={modelVM}
                //onModelChange={updateWizardData}
                resolveValue={readValue}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                onValueChange={handleValueChange}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
    );


}

UnderwritingInformationComponent.propTypes = wizardProps;
export default withRouter(UnderwritingInformationComponent);
